import { render } from "./email-button.vue?vue&type=template&id=330e7f2d&scoped=true"
import script from "./email-button.vue?vue&type=script&lang=js"
export * from "./email-button.vue?vue&type=script&lang=js"

import "./email-button.vue?vue&type=style&index=0&id=330e7f2d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330e7f2d"]])

export default __exports__